import { css, SerializedStyles } from '@emotion/core'
import React from 'react'

import { breakpoints } from '../constants/breakPoints'
import { IubendaPurpose } from '../types/iubenda'
import { Button } from './Button'
import SvgIcon from './SvgIcon'
import { openIubendaPreferences, useIubendaConsent } from './ThirdParty/iubenda'

interface ThirdPartyGuardProps {
  consentPurpose?: IubendaPurpose
  children: React.ReactNode
  blackBG?: boolean
  small?: boolean
  cssStyles?: SerializedStyles
}

const ThirdPartyGuard: React.FunctionComponent<ThirdPartyGuardProps> = ({
  consentPurpose = 'marketing',
  children,
  blackBG,
  small,
  cssStyles,
}) => {
  return useIubendaConsent(consentPurpose) ? (
    children
  ) : (
    <div css={[consentContainerStyle(blackBG), cssStyles]}>
      {!small && (
        <div className={`subtitle ${blackBG ? 'white-text' : ''} no-margin center`}>
          Currently third-party content is blocked due to your cookie preferences. <br className={'hide-on-small'} />
          Please revisit your cookie preferences to view this content:
        </div>
      )}
      <Button
        className={'strong-body-2'}
        cssStyles={iubendaButtonStyle(blackBG, small)}
        onClick={openIubendaPreferences}
      >
        <SvgIcon src={'logos/iubenda-logo'} />
        Privacy preferences
      </Button>
    </div>
  )
}

export default ThirdPartyGuard

const consentContainerStyle = (blackBG?: boolean) => css`
  position: absolute;
  box-sizing: border-box;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${blackBG ? '#000' : 'rgba(255, 255, 255, 0.2)'};
  ${!blackBG && 'backdrop-filter: blur(20px)'};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 6;
`

const iubendaButtonStyle = (blackBG?: boolean, small?: boolean) => css`
  ${!small && 'margin-top: 2rem'};
  padding: 1px 16px;
  display: flex;
  align-items: center;
  color: #1cc691;
  background-color: #fff;
  ${!blackBG && 'border: 1px solid #1cc691'};

  svg {
    width: 12px;
    margin-right: 0.75rem;
    transition: all 0.5s ease;
  }

  &:hover {
    text-decoration: underline;
    color: #1cc691;
    background-color: #fff;
  }

  @media screen and (max-width: ${breakpoints.small}px) {
    max-width: fit-content;
    ${!small && 'margin-top: 1rem'};
  }
`
